(function () {
  'use strict';

  function initHeader(scope) {
    var header = (scope && scope.querySelector) ? scope.querySelector('[data-header]') : document.querySelector('[data-header]');
    if (!header || header.dataset.miyoInitialized === '1') return;
    header.dataset.miyoInitialized = '1';
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var toggle = header.querySelector('[data-menu-toggle]');
    if (toggle) toggle.addEventListener('click', function () { header.classList.toggle('is-open'); });
    header.querySelectorAll('.mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () { header.classList.remove('is-open'); });
    });
  }

  function initReveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll ? root.querySelectorAll('.reveal:not([data-reveal-bound])') : [];
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute('data-reveal-bound', '1'); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '-40px 0px' });
      els.forEach(function (el, i) {
        el.style.transitionDelay = (Math.min(i % 6, 5) * 0.06) + 's';
        io.observe(el);
      });
    } else els.forEach(function (el) { el.classList.add('is-in'); });
  }

  function initFaq(scope) {
    var root = scope || document;
    root.querySelectorAll && root.querySelectorAll('[data-faq-q]:not([data-faq-bound])').forEach(function (btn) {
      btn.setAttribute('data-faq-bound', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        if (!item || !item.parentElement) return;
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
  }

  function initGallery(scope) {
    var root = scope || document;
    var main = document.querySelector('[data-gallery-main]');
    if (!main || !root.querySelectorAll) return;
    root.querySelectorAll('[data-gallery-thumb]:not([data-gallery-bound])').forEach(function (thumb) {
      thumb.setAttribute('data-gallery-bound', '1');
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.src = full;
        main.style.animation = 'none';
        void main.offsetWidth;
        main.style.animation = '';
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initQuantity(scope) {
    var root = scope || document;
    root.querySelectorAll && root.querySelectorAll('[data-qty]:not([data-qty-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-qty-bound', '1');
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-step'), 10) || 0;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initVariantForm(scope) {
    var form = (scope && scope.querySelector) ? scope.querySelector('[data-product-form]') : document.querySelector('[data-product-form]');
    var dataEl = document.getElementById('variant-data');
    if (!form || !dataEl || form.dataset.variantBound === '1') return;
    form.dataset.variantBound = '1';
    var variants;
    try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var atc = form.querySelector('[data-atc]');
    if (!idInput) return;
    var update = function () {
      var chosen = Array.prototype.map.call(form.querySelectorAll('[data-option-index]:checked'), function (i) { return i.value; });
      var match = variants.find(function (v) { return v.options.slice(0, chosen.length).every(function (o, i) { return o === chosen[i]; }); });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = (match.compare_at && match.compare_at > match.price ? '<s>' + match.compare_at_price + '</s>' : '') + match.price_formatted;
      if (atc) { atc.disabled = !match.available; atc.textContent = match.available ? atc.getAttribute('data-label') : atc.getAttribute('data-sold-out'); }
      try { var url = new URL(window.location.href); url.searchParams.set('variant', match.id); window.history.replaceState({}, '', url); } catch(e) {}
      form.querySelectorAll('[data-option-index]:checked').forEach(function (i) {
        var out = document.querySelector('[data-selected-' + i.getAttribute('data-option-index') + ']');
        if (out) out.textContent = i.value;
      });
    };
    form.querySelectorAll('[data-option-index]').forEach(function (i) { i.addEventListener('change', update); });
    update();
  }

  function init(scope) {
    try { initHeader(scope); initReveal(scope); initFaq(scope); initGallery(scope); initQuantity(scope); initVariantForm(scope); } catch (e) { console.warn('MIYŌ theme init:', e); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:reorder', function () { init(document); });
  document.addEventListener('shopify:section:select', function (event) { init(event.target); });
  document.addEventListener('shopify:section:deselect', function (event) { init(event.target); });
  document.addEventListener('shopify:inspector:activate', function (event) { init(event.target || document); });
})();